// Configuração efetiva da SPA (`.env` + `/config.json`), entregue pelo `AppProviders` (Parte 14.8).
import { createContext, useContext } from 'react';

import { type AppEnv, env } from './env';

export const AppEnvContext = createContext<AppEnv>(env);

export function useAppEnv(): AppEnv {
  return useContext(AppEnvContext);
}
